import * as echarts from "echarts";
import { msgBoradTabel, msgBoradNum, responMsg } from "../../api/messageBoard"
export default {
    data() {
        return {
            from: [{
                id: 0,
                userDate:"",
                userName:"",
                msgPage:"",
                userMsg:""


            }]


        }
    },
    mounted() {

    },
    methods: {
        //初始化图表
        inCharts() {
            this.myChart = echarts.init(document.getElementById("MessageBoardBox"));

            this.myChart.setOption(this.option);

            window.addEventListener("resize", () => {
                if (this.myChart) this.myChart.resize();
            });
        },
      
        //点击待审核列表的审核
        clickRowAaudit(a, b) {
            //每一行的ID
            // this.submitReply.msg_id = b[a].id
            // this.dialogFormVisible = true
            // console.log(a,b,6666666);
            this.$router.push(`/subscribAaudit`)
        },
        //确定提交回复
        handelSubmitReply() {

            this.fetchResponMsg(this.submitReply)
            this.dialogFormVisible = false
        },
        //报告发布
        handelReportRelease(){
            this.$router.push(`/subscribeRelease`)
        }

    }
}